import zDownload from './src/main.vue';
zDownload.install = (Vue) => {
	Vue.component(zDownload.name, zDownload);
};
export default zDownload;
